import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useFormContext } from "react-hook-form";

// Redux
import { getCountriesUser, useCountryReducer } from "@/main/store/country";

// Services
import { getDefaultOptionDrop, getTranslateByKey } from "@/main/services/utils";
import { StatusRegisterEnum } from "@/main/services/enum/StatusRegisterEnum";

// Types
import { KeyValue } from "@/main/models/common";

// Api

// Components
import KOGSection from "@/main/components/shared/kogSection/kogSection";
import KogInputTextControlledNew from "@/main/components/shared/inputText/inputTextControlledNew";
import KogAutoCompleteControlled from "@/main/components/shared/inputAutoComplete/autoCompleteControlled";

import * as S from "./styles";
import { DynamicReportForm } from "../../registerDynamicReport";

function GeneralDataSection() {
	const dispatch = useDispatch();
	const countryReducer = useCountryReducer();
	const optionDefaultCountryDrop = getDefaultOptionDrop(countryReducer.countriesUser.data);

	const { control, setValue } = useFormContext<DynamicReportForm>();

	const statusOptions: KeyValue[] = [
		{
			key: StatusRegisterEnum.Active,
			value: getTranslateByKey("statusRegister.active"),
		},
		{
			key: StatusRegisterEnum.Suspended,
			value: getTranslateByKey("statusUser.suspended"),
		},
	];

	useEffect(() => {
		dispatch(getCountriesUser());
	}, []);

	return (
		<KOGSection title={getTranslateByKey("dynamicReport.generalData")}>
			<S.GenralDataContainer>
				<KogAutoCompleteControlled
					label={getTranslateByKey("information.country")}
					nameCustom="country"
					control={control}
					rulesCustom={{ required: true }}
					isDefaultValueUnique
					autoOnChangeCustom
					autoHighlightCustom={!!optionDefaultCountryDrop}
					disabled={!!optionDefaultCountryDrop}
					setValueCustom={setValue}
					onChangeCustom={() => {}}
					options={countryReducer.countriesUser.data}
					isLoading={countryReducer.countriesUser.isLoading}
					id="id-dynamicReport-register-country"
				/>
				<S.ReportNameArea>
					<KogInputTextControlledNew
						label={getTranslateByKey("dynamicReport.reportName")}
						name="reportName"
						control={control}
						controllerProps={{ rules: { required: true } }}
						inputProps={{ maxLength: 200 }}
						id="id-dynamicReport-register-reportName"
					/>
				</S.ReportNameArea>
				<KogAutoCompleteControlled
					label={getTranslateByKey("information.status")}
					nameCustom="statusRegister"
					control={control}
					rulesCustom={{ required: true }}
					onChangeCustom={() => {}}
					options={statusOptions}
					id="id-dynamicReport-register-status"
				/>
			</S.GenralDataContainer>
		</KOGSection>
	);
}

export default GeneralDataSection;
